import {
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
	OnChanges,
} from "@angular/core";

@Component({
	selector: "app-page-title",
	templateUrl: "./page-title.directive.html",
	styleUrls: ["./page-title.directive.css"],
	encapsulation: ViewEncapsulation.None,
})
export class PageTitleDirective implements OnInit, OnChanges {
	@Input() pageTitle: String;
	@Input() fontSize: String;
	@Input() textDirection: String;

	public text1: String;
	public text2: String;

	constructor() {}

	ngOnInit() {}
	ngOnChanges(changes) {
		if (this.pageTitle.indexOf("|") != -1) {
			let splitArr = this.pageTitle.split("|");
			this.text1 = splitArr[0];
			this.text2 = splitArr[1];
		} else {
			this.text1 = this.pageTitle;
		}
		console.log("this.text1 ", this.text1);
		console.log("this.text2 ", this.text2);
	}
}
